
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';
import { getResource, putResource } from '../../../../framework/client/resource';
import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import { AccountType } from '../../../../../common/application/model/enums/AccountType';
import { Account } from '../../../../../common/application/model/Account';
import { getEnumerationOptions } from '../../../../framework/service/options';
import SwitchField from '../../../../framework/fields/SwitchField.vue';
import { getCustomerOptions } from '../../../service/application_options_service';
import PercentageField from '../../../../framework/fields/PercentageField.vue';
import { ValidationObserver } from 'vee-validate';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { errorToast, successToast } from '../../../service/toast_service';

@Component({
    components: { SelectField, TextField, SwitchField, PercentageField, ValidationObserver },
})
export default class EditAccount extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.ACCOUNT;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as Account,
        accountTypeOptions: [] as { id: string | undefined; label: string }[],
        customerOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.accountTypeOptions = getEnumerationOptions('AccountType', Object.keys(AccountType), this);
        this.local.row = (await getResource<Account>(this.resourceType, this.id))!!;
        this.local.customerOptions = await getCustomerOptions();
    }

    async saveAndClose() {
        try {
            await putResource(this.resourceType, this.id, this.local.row);
            successToast(this, 'message.accountSaved');
            this.back();
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
